import { ItemCombobox } from '@models-global/model-combobox-item';
import { ReportType } from '@module-report/enums/report-type.enum';

export const ARRAY_INVOICE_REPORTS: ReadonlyArray<ItemCombobox> = [
  {
    value: ReportType.PHARMACY_INVOICE_NCPDP,
    text: 'Manufacturer Pharmacy Invoice NCPDP'
  },
  {
    value: ReportType.PHARMACY_INVOICE_NCPDP_PN,
    text: 'Manufacturer Pharmacy Invoice NCPDP with PN'
  },
  {
    value: ReportType.PHARMACY_INVOICE_NDC_SUMMARY,
    text: 'Manufacturer Pharmacy Invoice NDC Summary'
  },
  {
    value: ReportType.PHARMACY_INVOICE_PLAN_NDC_SUMMARY,
    text: 'Manufacturer Pharmacy Invoice Plan NDC Summary'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP,
    text: 'Manufacturer Pharmacy Market Basket NCPDP'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP_PN,
    text: 'Manufacturer Pharmacy Market Basket NCPDP with PN'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP_PN_ONLY,
    text: 'Manufacturer Pharmacy Market Basket NCPDP PN Only'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_SHARE,
    text: 'Manufacturer Pharmacy Market Basket Share'
  },
  { value: ReportType.INVOICE_SUMMARY, text: 'Client Invoice Summary' },
  {
    value: ReportType.INVOICE_PLAN_SUMMARY,
    text: 'Client Invoice Plan Summary'
  },
  {
    value: ReportType.INVOICE_PLAN_DRUG_SUMMARY,
    text: 'Client Invoice Plan Drug Summary'
  },
  { value: ReportType.EXCLUSION_REPORT, text: 'Client Exclusion Report' },
  {
    value: ReportType.CLAIM_DATA_LOAD_SUMMARY,
    text: 'Client Claim Data Load Summary'
  },
  { value: ReportType.MEDICAL_INVOICE_NCPDP, text: 'Medical Invoice NCPDP' },
  {
    value: ReportType.MEDICAL_INVOICE_NCPDP_PN,
    text: 'Medical Invoice NCPDP with PN'
  },
  {
    value: ReportType.MEDICAL_INVOICE_NDC_SUMMARY,
    text: 'Medical Invoice NDC Summary'
  },
  {
    value: ReportType.MEDICAL_INVOICE_PLAN_NDC_SUMMARY,
    text: 'Medical Invoice Plan NDC Summary'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP,
    text: 'Medical Market Basket NCPDP'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP_PN,
    text: 'Medical Market Basket NCPDP with PN'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP_PN_ONLY,
    text: 'Medical Market Basket NCPDP PN Only'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_SHARE,
    text: 'Medical Market Basket Share'
  }
];

export const ARRAY_MFG_REPORTS: ReadonlyArray<ItemCombobox> = [
  { value: ReportType.PHARMACY_INVOICE_NCPDP, text: 'Pharmacy Invoice NCPDP' },
  {
    value: ReportType.PHARMACY_INVOICE_NCPDP_PN,
    text: 'Pharmacy Invoice NCPDP with PN'
  },
  {
    value: ReportType.PHARMACY_INVOICE_NDC_SUMMARY,
    text: 'Pharmacy Invoice NDC Summary'
  },
  {
    value: ReportType.PHARMACY_INVOICE_PLAN_NDC_SUMMARY,
    text: 'Pharmacy Invoice Plan NDC Summary'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP,
    text: 'Pharmacy Market Basket NCPDP'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP_PN,
    text: 'Pharmacy Market Basket NCPDP with PN'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_NCPDP_PN_ONLY,
    text: 'Pharmacy Market Basket NCPDP PN Only'
  },
  {
    value: ReportType.PHARMACY_MARKET_BASKET_SHARE,
    text: 'Pharmacy Market Basket Share'
  },
  { value: ReportType.MEDICAL_INVOICE_NCPDP, text: 'Medical Invoice NCPDP' },
  {
    value: ReportType.MEDICAL_INVOICE_NCPDP_PN,
    text: 'Medical Invoice NCPDP with PN'
  },
  {
    value: ReportType.MEDICAL_INVOICE_NDC_SUMMARY,
    text: 'Medical Invoice NDC Summary'
  },
  {
    value: ReportType.MEDICAL_INVOICE_PLAN_NDC_SUMMARY,
    text: 'Medical Invoice Plan NDC Summary'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP,
    text: 'Medical Market Basket NCPDP'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP_PN,
    text: 'Medical Market Basket NCPDP with PN'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_NCPDP_PN_ONLY,
    text: 'Medical Market Basket NCPDP PN Only'
  },
  {
    value: ReportType.MEDICAL_MARKET_BASKET_SHARE,
    text: 'Medical Market Basket Share'
  }
];

export const ARRAY_CUSTOMER_REPORTS: ReadonlyArray<ItemCombobox> = [
  { value: ReportType.INVOICE_SUMMARY, text: 'Invoice Summary' },
  { value: ReportType.INVOICE_PLAN_SUMMARY, text: 'Invoice Plan Summary' },
  {
    value: ReportType.INVOICE_PLAN_DRUG_SUMMARY,
    text: 'Invoice Plan Drug Summary'
  },
  { value: ReportType.EXCLUSION_REPORT, text: 'Exclusion Report' },
  { value: ReportType.CLAIM_DATA_LOAD_SUMMARY, text: 'Claim Data Load Summary' }
];

export const ARRAY_CUSTOMER_REPORTS_GUARANTEED_REBATE: ReadonlyArray<ItemCombobox> =
  [
    { value: ReportType.EXCLUSION_REPORT, text: 'Exclusion Report' },
    {
      value: ReportType.CLAIM_DATA_LOAD_SUMMARY,
      text: 'Claim Data Load Summary'
    }
  ];
